import { useEffect } from "react";
import { useStoreState, useStoreActions } from "easy-peasy";
import { useSnackbar } from "notistack";
import NotifyClose from "../Common/NotifierClose";

let displayed = [];

export default function Notifier() {
  const notifications = useStoreState(state => state.notifier.data);
  const removeNotification = useStoreActions(
    actions => actions.notifier.remove
  );
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = id => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = id => {
    displayed = [...displayed.filter(key => id !== key)];
  };

  useEffect(() => {
    notifications.forEach(
      ({ key, message, options = {}, dismissed = false }) => {
        // console.log("options", options);
        if (dismissed) {
          // dismiss snackbar using notistack
          closeSnackbar(key);
          return;
        }

        // do nothing if snackbar is already displayed
        if (displayed.includes(key)) return;

        // display snackbar using notistack
        enqueueSnackbar(message, {
          key,
          ...options,
          onClose: (event, reason, myKey) => {
            if (options.onClose) {
              options.onClose(event, reason, myKey);
            }
          },
          onExited: (event, myKey) => {
            // remove this snackbar from redux store
            removeNotification(myKey);
            removeDisplayed(myKey);
          },
          action: key => (
            <NotifyClose notificationKey={key} text={options.text} />
          )
        });

        // keep track of snackbars that we've displayed
        storeDisplayed(key);
      }
    );
  }, [notifications, closeSnackbar, enqueueSnackbar, removeNotification]);

  return null;
}
